import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ServicioDemandaInducidaService {

  private REPORTES_API: string = '';

  constructor(private http: HttpClient) {
    this.REPORTES_API = environment.API_REPORTES;
  }

  public getDemandasInducidas(code: string, historia: number) {
    const URL = `${this.REPORTES_API}/demanda-inducida/?code=${code}&historia=${historia}`;
    const HTTP_HEADER = new HttpHeaders({ 'Content-Type': 'application/x-www-form-urlencoded' });

    return this.http.get(URL, { headers: HTTP_HEADER });
  }
}
